export default __webpack_public_path__ + "assets/4c65efccf1fb1c73d18b2d1b7c531174.png";